import { _ } from '_core';

import { DraftParams } from './types';

export const validate = (params: DraftParams) => {
  if (_.isEmpty(params.columns)) return ['There is no selection of columns.'];
  return [];
};
